import { CheckCircleFilled } from '@ant-design/icons';
import { Progress } from 'antd';
import colorTokens from '../../../../constants/design_system/colors';
import { Column } from '../../../../types/WorkspaceViewColumn';

type GroupProgressIndicatorProps = {
  groupBy: string;
  completedTasksCount: number;
  totalTasksCount: number;
  taskCompletionPercent: number;
};

export const GroupProgressIndicator = ({
  groupBy,
  completedTasksCount,
  totalTasksCount,
  taskCompletionPercent,
}: GroupProgressIndicatorProps) => {
  // For status grouping, show simple count badge
  if (groupBy === Column.status) {
    return (
      <span className="min-w-[24px] h-6 px-1.5 bg-neutral-200 rounded inline-flex justify-center items-center text-neutral-700 text-sm font-medium font-['Figtree'] leading-tight">
        {totalTasksCount}
      </span>
    );
  }

  // For other groupings, show progress indicator
  return (
    <div className="h-6 flex items-center gap-2">
      {taskCompletionPercent === 100 ? (
        <div className="w-4 h-4 flex items-center justify-center">
          <CheckCircleFilled style={{ fontSize: '16px' }} className="text-taskonioGreen-600" />
        </div>
      ) : (
        <Progress
          type="circle"
          percent={taskCompletionPercent}
          size={16}
          strokeWidth={12}
          strokeColor={colorTokens.taskonioGreen[600]}
          trailColor={colorTokens.neutral[600]}
          showInfo={false}
        />
      )}
      <span className="text-neutral-900 text-sm font-normal">
        {completedTasksCount}/{totalTasksCount}
      </span>
    </div>
  );
};
